module.exports = __webpack_public_path__ + "static/uv_5-b3f99c1f97bfa11663b4c23787fa5dbb.png";